import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getDriverFields() {
  const response = await defaultFetch('/form/Driver/Fields');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useDriverFields() {
  return useQuery({
    queryKey: ['driver-fields'],
    queryFn: async () => getDriverFields(),
    refetchOnWindowFocus: false
  });
}
